import { render, staticRenderFns } from "./PreviewTree.vue?vue&type=template&id=018c584c&scoped=true&"
import script from "./PreviewTree.vue?vue&type=script&lang=js&"
export * from "./PreviewTree.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTree.vue?vue&type=style&index=0&id=018c584c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c584c",
  null
  
)

export default component.exports